// extracted by mini-css-extract-plugin
export default {"root":"ObVU17yjLC"};